{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -172.3597602302871,
              51.0869877326102
            ],
            [
              -144.18561768439363,
              57.495944524534224
            ],
            [
              -125.11291877023285,
              49.17851676478193
            ],
            [
              -129.24544931312656,
              55.584482071445905
            ],
            [
              -135.44628698415747,
              59.911539695274655
            ],
            [
              -141.3030983076216,
              60.434141863667435
            ],
            [
              -140.80623312325997,
              72.14938422907159
            ],
            [
              -169.47655122832734,
              70.95946625306539
            ],
            [
              -167.6563447005465,
              64.29210409579375
            ],
            [
              -172.3597602302871,
              51.0869877326102
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}